// 菜单视图组件
const menuViewMap = {};

// 合并菜单视图组件
export function addMenuViewMap(obj) {
  if (obj) {
    for (const key of Object.keys(obj)) {
      menuViewMap[key] = obj[key];
    }
  }
}

export default menuViewMap;
